const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function fallbackRequestId(): string {
  const bytes = new Uint8Array(16);
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
    16,
    20
  )}-${hex.slice(20)}`;
}

export function createRequestId(): string {
  return globalThis.crypto?.randomUUID?.() ?? fallbackRequestId();
}

export function withRequestId(headersInit?: HeadersInit): { headers: Headers; requestId: string } {
  const headers = new Headers(headersInit);
  const existing = headers.get('X-Request-Id');
  const requestId = existing && UUID_RE.test(existing) ? existing : createRequestId();
  headers.set('X-Request-Id', requestId);
  return { headers, requestId };
}

export function responseRequestId(res: Response, fallbackRequestId: string): string {
  return res.headers.get('X-Request-Id') ?? fallbackRequestId;
}
